import React from 'react'
import Footer from '../components/Footer/Footer'
import './pagestyles/Moon.css'

const BIBLE_VERSES = [
  {
    reference: 'Philippians 4:13',
    text: 'I can do all this through him who gives me strength.',
  },
  {
    reference: 'Jeremiah 29:11',
    text: 'For I know the plans I have for you,” declares the LORD, “plans to prosper you and not to harm you, plans to give you hope and a future.',
  },
  {
    reference: 'Proverbs 3:5-6',
    text: 'Trust in the LORD with all your heart and lean not on your own understanding; in all your ways submit to him, and he will make your paths straight.',
  },
  {
    reference: 'Isaiah 40:31',
    text: 'But those who hope in the LORD will renew their strength. They will soar on wings like eagles; they will run and not grow weary, they will walk and not be faint.',
  },
  {
    reference: 'Romans 8:28',
    text: 'And we know that in all things God works for the good of those who love him, who have been called according to his purpose.',
  },
  {
    reference: 'Psalm 23:1',
    text: 'The LORD is my shepherd, I lack nothing.',
  },
  {
    reference: 'Joshua 1:9',
    text: 'Have I not commanded you? Be strong and courageous. Do not be afraid; do not be discouraged, for the LORD your God will be with you wherever you go.',
  },
]

const getDayOfYear = (date = new Date()) => {
  const start = new Date(date.getFullYear(), 0, 0)
  const diff = date - start
  const oneDay = 1000 * 60 * 60 * 24

  return Math.floor(diff / oneDay)
}

function Moon() {
  const dayOfYear = getDayOfYear()
  const verseIndex = dayOfYear % BIBLE_VERSES.length
  const dailyVerse = BIBLE_VERSES[verseIndex]

  return (
    <div className='moonPage'>
      <div className='moonPageContent moonPageStack'>
        <div className='moonCard'>
          <p>
            “You are the light of the world—like a city on a hilltop that cannot be hidden.
            No one lights a lamp and then puts it under a basket. Instead,
            a lamp is placed on a stand, where it gives light to everyone in the house.
            In the same way, let your good deeds shine out for all to see,
            so that everyone will praise your heavenly Father.”
          </p>
          <div className='verse'>
            — Matthew 5:14-16
          </div>
        </div>

        <div className='moonDivider' aria-hidden='true' />

        <div className='dailyVerseSection'>
          <span className='dailyVerseLabel'>Daily Verses from Kushim</span>
          <div className='dailyVerseCard'>
            <blockquote className='dailyVerseText'>“{dailyVerse.text}”</blockquote>
            <p className='dailyVerseReference'>— {dailyVerse.reference}</p>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  )
}

export default Moon